import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { DishServices } from "../dish/services";
import { IngredientsServices } from "../ingredients/services";
import { ProductsServices } from "../products/services";
import { MenuServices } from "../menu/services";
import { HttpClient, HttpParams } from '@angular/common/http';
import { Globals } from '../../globals';
import { NotificationsServices } from '../services/notificationsServices';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../services/analyticsServices';

interface Ingredient {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;

}

interface Product {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  pvp: number;
}

interface List {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  pvp: number;
  type: string;
  values: object;
}

interface Variation {
  UID: string;
  UID_RESTAURANT: string;
  measurement: string;
  name: string;
  price: number;
  quantity: number;
  type: string;
  uid_element: string;
}

@Injectable()
export class StockServices {
  private firestore: any;

  ingredientsCol: AngularFirestoreCollection<Ingredient>;
  productCol: AngularFirestoreCollection<Product>;

  listing: Observable<List[]>;
  listprod: Observable<List[]>;

  variationCol: AngularFirestoreCollection<Variation>;
  variationDoc: AngularFirestoreDocument<Variation>;
  variations: Observable<Variation[]>;

  checkStock: boolean = false;

  public liststockmax_array_tmp = Array();
  public liststockmin_array_tmp = Array();

  pagesIngprod: any;
  limit_pages: number;
  page_active: number = 1;

  public show_products: boolean = true;
  public show_ingredients: boolean = true;
  public show_compound_ingredients: boolean = true;

  constructor(public afs: AngularFirestore,
    public dishServices: DishServices,
    public productsServices: ProductsServices,
    public ingredientsServices: IngredientsServices,
    public menuServices: MenuServices,
    public http: HttpClient,
    public globals: Globals,
    private notifServices: NotificationsServices,
    private translate: TranslateService,
    public analyticsServices: AnalyticsServices) {
    this.firestore = firebase.firestore();
  }

  /*GET INGS/PRODS MINMAX*/
  async getListStockMaxMin() {

    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    this.http.post(this.globals.analytics_path + 'stock/get_top_stock_max_min', params, {})
      .subscribe(async res => {
        this.liststockmax_array_tmp = res['liststockmax_array_tmp'];
        this.liststockmin_array_tmp = res['liststockmin_array_tmp'];
        this.checkStock = true;
      });
  }

  //calcular stocks(llamar funcion) y hacer update en bbdd
  async updateDeductedStock(type, proding, foodcost_parts, operation, number, units) {
    //DISH
    if (type == 'dish') {
      var dish_ingredient = await this.ingredientsServices.getIngredient(proding.uid);//recupera ingrediente
      if (!dish_ingredient.sub_recipe) {
        //calcula stock
        var _stock = this.calculateMeasurements(dish_ingredient.measurement, parseFloat(dish_ingredient.stock), this.divideQuantityFoodcostparts(foodcost_parts, proding.quantity_gross), units);
        if (operation == 'divide') {//variacion que es plato para dividir entre cantidad (1, 1/2, 1/4)
          _stock = _stock / number;
        } else {//caso normal elemento
          _stock = _stock - number;
        }
        //update
        this.ingredientsServices.afs.collection('ingredients').doc(proding.uid).update({
          'stock': this.checkIfStockNegative(_stock),
        });

        //Comprovamos si el stock actual del ingrediente, es igual o menor a alerta_stock, para enviar notificacion
        this.notifMinStock(_stock, dish_ingredient.stock_alert, dish_ingredient.name);

      }
      //PRODUCT
    } else if (type == 'product') {
      if (proding.sub_recipe) {//producto con foodcost
        for (let proing of proding.foodcost) {//recorre ingredientes del foodcost
          var ingredient = await this.ingredientsServices.getIngredient(proing.uid);//recupera ingrediente entero
          if (!ingredient.sub_recipe) {
            var quantity_minus = 0;
            if (operation == 'multiply') {//caso de variacion multiplica por numero de unidades
              quantity_minus = this.divideQuantityFoodcostparts(foodcost_parts, proing.quantity_gross) * number;
            } else {//caso normal elemento
              quantity_minus = this.divideQuantityFoodcostparts(foodcost_parts, proing.quantity_gross);
            }
            var _stock_ing = this.calculateMeasurements(ingredient.measurement, parseFloat(ingredient.stock), quantity_minus, units);//calculo stock
            //update
            this.ingredientsServices.afs.collection('ingredients').doc(proing.uid).update({
              'stock': this.checkIfStockNegative(_stock_ing),
            });

            //Comprovamos si el stock actual del ingrediente, es igual o menor a alerta_stock, para enviar notificacion
            this.notifMinStock(_stock_ing, ingredient.stock_alert, ingredient.name);
          }

        }
      } else {//producto basico
        //resta ud.
        var _stock_prod = this.calculateMeasurements(proding.measurement, parseFloat(proding.stock), this.divideQuantityFoodcostparts(foodcost_parts, proding.quantity_gross), units);
        //update
        this.productsServices.afs.collection('products').doc(proding.uid).update({
          'stock': _stock_prod,
        });

        //Comprovamos si el stock actual del ingrediente, es igual o menor a alerta_stock, para enviar notificacion
        this.notifMinStock(_stock_prod, proding.stock_alert, this.globals.nameLangSelectProduct(proding));
      }
    }
  }

  //calcula dependiendo de la medida (kg, l, ud.)
  calculateMeasurements(measurement, stock, minus_stock, units) {
    //multiplicar minus_stock(lo que se resta) por las units(unidades de ese elemento)
    var return_stock = 0;
    if (measurement === 'kg' || measurement === 'l') {
      //kg l
      var stock_grams_ml = stock * 1000;
      var total = stock_grams_ml - (minus_stock * units);
      return_stock = total / 1000;
    } else if (measurement === 'ud.') {
      return_stock = stock - (1 * units);
    } else {
      return_stock = parseFloat(stock) - (parseFloat(minus_stock) * units);
    }
    return this.checkIfStockNegative(return_stock.toFixed(2));
  }

  //calcula variacion ud
  calculateVariationProduct(stock, minus_stock) {
    var return_stock = 0;
    return_stock = stock - minus_stock;

    return this.checkIfStockNegative(return_stock.toFixed(2));
  }

  //retorna la quantitat de una/1 racion
  divideQuantityFoodcostparts(parts, quantity) {
    return parseFloat(quantity) / parseFloat(parts);
  }

  //funcion que pasa variacion plato y devuelve por cuanto hay que dividir
  getPercentOfQuantity(quantity) {
    if (quantity == '1') {
      return 1;
    } else if (quantity == '1/2') {
      return 0.5;
    } else {
      return 0.25;
    }
  }

  //funcion que mira si el numero pasado es negativo(siempre devuelve numero o 0)
  checkIfStockNegative(stock) {
    if (stock >= 0) {
      return parseFloat(stock);
    } else {
      return 0;
    }
  }

  //funcion que recupera la variacion a partir de la UID
  async getVariation(UID) {
    const varRef = this.firestore.collection('variations').doc(UID);
    var _variation;

    await varRef.get().then(doc => {
      _variation = doc.data();
      _variation.UID = doc.id;
    });

    return _variation
  }

  //Buscador de Stock
  public filteredStockProd: any;
  public filteredStockActive: boolean = false;
  searchStockNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredStockActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'stock/filter_stock_max_min', params, {})
          .subscribe(async res => {
            this.filteredStockProd = res;
            this.filteredStockActive = true;
          });
      } else {
        this.filteredStockActive = false;
      }
    }
  }

  get_ingprod_done: boolean = false;
  ingprod_array_tmp: any = [];
  list_ingprod_array: any = [];
  ingprod_array_filtered: any = [];
  ingprod_searchbar_text: any = '';
  async getIngProd(loader) {
    this.get_ingprod_done = loader;
    
    // ✅ LIMPIAR SOLO los arrays que se usan DENTRO de esta función
    this.ingprod_array_tmp = [];
    this.ingprod_updateinventory = [];
    this.get_ingprod_updateinventory_done = false;

    //Miramos si la licencia tiene límite de stock 
    if (!this.globals.checkLimitsByLicense('stock', 'ings')) {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('type', 'all');
      await this.http.post(this.globals.analytics_path + 'paginate/stock_products', params, {})
        .subscribe(async res => {
          this.ingprod_array_tmp = res['list'];
          this.ingprod_updateinventory = res['list'];

          if (this.ingprod_array_tmp.length != 0) {
            this.getListDishesProductsMinMax();
            this.changePLG();
          } else {
            this.get_ingprod_done = true;
          }
        });
    } else {
      //Si no tiene límite le mandamos a recuperar con el paginador
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid);
      await this.http.post(this.globals.analytics_path + 'paginate/all_ingredients_products', params, {})
        .subscribe(async res => {
          this.ingprod_array_tmp = res['list'];
          this.ingprod_updateinventory = this.ingprod_updateinventory.filter(item => item.sub_recipe === false);
          this.get_ingprod_updateinventory_done = true;


          // para actulizar inventario stock en seccion actulizar inventario 
          this.ingprod_updateinventory = res['list'];
          this.ingprod_updateinventory = this.ingprod_updateinventory.filter(item => item.sub_recipe === false);
          this.get_ingprod_updateinventory_done = true;

          if (this.ingprod_array_tmp.length != 0) {
            this.getListDishesProductsMinMax();
            this.changePLG();
          } else {
            this.get_ingprod_done = true;
          }
        });
    }

  }

  getListDishesProductsMinMax() {
    this.get_ingprod_done = true;
    //Ordenamos el array
    this.ingprod_array_tmp.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
    //For para poner en activo los platos que puede ver el free.
    this.ingprod_array_tmp.forEach((value, index) => {
      value._active = true;
      if (index >= this.globals.checkLimitsByLicense('stock', 'ings_prods') && this.globals.checkLimitsByLicense('stock', 'ings_prods') != -1) {
        value._active = false;
      }
    });
    this.list_ingprod_array = this.ingprod_array_tmp;
    this.ingprod_array_filtered = this.ingprod_array_tmp;
    this.ingprodSearch(this.ingprod_searchbar_text);
  }

  ingprodSearch(value) {
    if (value) {
      if (value != 'Sin categoria') {
        this.ingprod_array_filtered = this.list_ingprod_array.filter(objeto => {
          return this.globals.objectToArray(objeto).some(valor => {
            if (typeof valor === 'string' || typeof valor === 'number') {
              // Comparar como string
              return valor.toString().toLowerCase().includes(value.toLowerCase());
            } else if (Array.isArray(valor)) {
              // Buscar en cada elemento del array
              return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
            }
            return false;
          });
        });
      } else {
        this.ingprod_array_filtered = this.list_ingprod_array.filter(objeto => {
          if (objeto.tags == undefined || objeto.tags.length == 0) {
            return true;
          }
          return false;
        });
      }
    } else {
      this.ingprod_array_filtered = this.list_ingprod_array;
    }
    this.filter(true);
  }

  filter(from_search = false) {
    var _array = this.list_ingprod_array;
    if (from_search) {
      _array = this.ingprod_array_filtered;
    }
    this.ingprod_array_filtered = _array.filter(element => {
      if (this.show_products && element.type === "product") {
        return true;
      }
      if (this.show_ingredients && element.type === "ingredient") {
        return true;
      }
      if (this.show_compound_ingredients && element.type === "ingredient" && element.sub_recipe === true) {
        return true;
      }
      return false;
    });
  }

  ingprod_updateinventory = [];
  get_ingprod_updateinventory_done: boolean = false;
  async getIngredients() {
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);

    await this.http.post(this.globals.analytics_path + 'get/ingredients', params, {})
      .subscribe(async res => {
        this.ingprod_updateinventory = res['list'];
        this.ingprod_updateinventory = [...this.ingprod_updateinventory];

        this.get_ingprod_updateinventory_done = true;
      });
  }

  notifMinStock(stock, min_stock, element_name) {
    //Si el min_stock es diferente a 0, y si el elemento es igual o menor al minimo de stock, se envia una notificacion
    //y comprovamos la licencia para ver si puede recibir notificaciones 
    if (min_stock != 0 && stock <= min_stock && this.globals.checkLimitsByLicense('stock', 'alert')) {
      let _notification = {};

      //Preparamos la notificacion en enviar
      _notification = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'title': this.translate.instant('notification-push-call-min-stock-title'),
        'description': this.translate.instant('notification-push-call-min-stock-desc-1') + " " + element_name + " " + this.translate.instant('notification-push-call-min-stock-desc-2'),
      }
      //Enviamos la notificacion
      this.notifServices.notificationPushAllRestaurant(_notification);
    }
  }

  changePLG() {
    if (this.globals.restaurant.plg_stock_finisher === undefined || this.globals.restaurant.plg_stock_finisher === false) {
      //save plg_stock_starter true
      this.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_stock_finisher: true
      });
      this.globals.restaurant.plg_stock_finisher = true;
      this.analyticsServices.trackingExpStock('finisher', this.globals.tracking_exp['finisher'], '');
      this.globals.updateERPNextCustomer();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/stock/services.ts